import { useCallback, useEffect, useState } from 'react';

import * as ROUTE from '../constants/routes'
import useDidMount from './useDidMount';

const useWallets = () => {
  const [walletsList, setWalletsList] = useState([]);
  const [walletCount, setWalletCount] = useState([]);
  const [walletBalance, setWalletBalance] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isDidMount = useDidMount();

  const fetchWalletsList = useCallback(async () => {
    try {
      const authToken = JSON.parse(localStorage.getItem(process.env.REACT_APP_ADMIN_AUTH_TOKEN));
      const requestOptions = {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${authToken.token}`
        }
      }
      if (walletsList.length === 0 && isDidMount) {
        setLoading(true);
        setError('');
        const _wallets =  await fetch(`${ROUTE.ADMIN_API}/wallets`, 
          requestOptions)
        .then(res => res.json())
        .then(data =>{
          return data
        })
        .catch(err => console.log(err))
        if (!_wallets?.data) {
          if (isDidMount) {
            setError('No wallet found.');
            setLoading(false);
          }
        } else {
          const data = _wallets;
          if (isDidMount) {
            setLoading(false);
            setWalletsList(data);
          }
        }
      }
    } catch (e) {
      if (isDidMount) {
        setError('Failed to fetch wallets');
        setLoading(false);
      }
    }
  }, [isDidMount, walletsList]);

  useEffect(() => {
    fetchWalletsList();
  }, [fetchWalletsList]);

  const fetchWalletCount = useCallback(async () => {
    try {
      setLoading(true);
      const authToken = JSON.parse(localStorage.getItem(process.env.REACT_APP_ADMIN_AUTH_TOKEN));
      const requestOptions = {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${authToken.token}`
        }
      }
      if (walletCount.length === 0 && isDidMount) {
        const _walletCount =  await fetch(`${ROUTE.ADMIN_API}/wallets/count`, 
          requestOptions)
        .then(res => res.json())
        .then(data =>{
          return data
        })
        .catch(err => console.log(err))
        if (!_walletCount?.data) {
          if (isDidMount) {
            setLoading(false);
          }
        } else {
          const data = _walletCount;
          if (isDidMount) {
            setLoading(false);
            setWalletCount(data.data);
          }
        }
      }
    } catch (e) {
      if (isDidMount) {
        setError('Failed to fetch wallet count');
        setLoading(false);
      }
    }
  }, [isDidMount, walletCount]);

  const fetchWalletBalance = useCallback(async () => {
    try {
      setLoading(true);
      const authToken = JSON.parse(localStorage.getItem(process.env.REACT_APP_ADMIN_AUTH_TOKEN));
      const requestOptions = {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${authToken.token}`
        }
      }
      if (walletBalance.length === 0 && isDidMount) {
        const _walletBalance =  await fetch(`${ROUTE.ADMIN_API}/wallets/balance`, 
          requestOptions)
        .then(res => res.json())
        .then(data =>{
          return data
        })
        .catch(err => console.log(err))
        if (!_walletBalance?.data) {
          if (isDidMount) {
            setLoading(false);
          }
        } else {
          const data = _walletBalance;
          if (isDidMount) {
            setLoading(false);
            setWalletBalance(data.data);
          }
        }
      }
    } catch (e) {
      if (isDidMount) {
        setError('Failed to fetch wallet balance');
        setLoading(false);
      }
    }
  }, [isDidMount, walletBalance]);

  return {
    fetchWalletsList, fetchWalletCount, fetchWalletBalance,
    walletsList, walletCount, walletBalance, isLoading, error
  };
};

export default useWallets;
